import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const DA_MONTHS = [
    'januar', 'februar', 'marts', 'april', 'maj', 'juni',
    'juli', 'august', 'september', 'oktober', 'november', 'december'
];

/** ISO 8601 order: 1 = Monday. */
const DA_WEEKDAYS = ['mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag', 'søndag'];

/**
 * Danish labels for the day picker.
 *
 * Provided on the filters component rather than through LOCALE_ID: the app has never registered a
 * locale, so it runs on en-US, and every existing date is rendered with an explicit numeric pattern
 * that reads the same either way. This calendar is the first place month and weekday *names* appear,
 * and switching LOCALE_ID globally to fix one component would quietly change date output everywhere.
 *
 * It must stay on the component that renders the datepicker — a provider left on a parent page would
 * silently give the other host page an English calendar.
 */
@Injectable()
export class DanishDatepickerI18n extends NgbDatepickerI18n {
    getWeekdayLabel(weekday: number, width?: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined>): string {
        const name = DA_WEEKDAYS[weekday - 1] ?? '';
        if (width === 'long') return name;
        // The column headers are single letters, which is what makes M T O T F L S read as Danish.
        return width === 'short' ? name.slice(0, 3) : name.charAt(0).toUpperCase();
    }

    getMonthShortName(month: number): string {
        return DA_MONTHS[month - 1]?.slice(0, 3) ?? '';
    }

    getMonthFullName(month: number): string {
        return DA_MONTHS[month - 1] ?? '';
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}. ${DA_MONTHS[date.month - 1]} ${date.year}`;
    }
}

/** ng-bootstrap counts months from 1, JavaScript from 0. */
export function toDateStruct(date: Date): NgbDateStruct {
    return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
}
